import {useEffect,useState} from 'react';
import {Card, Col, Row, Spinner} from "reactstrap";
import LogoLRF from "../../AppSystem/assets/img/LRF_Logga.png"
import {useTranslation} from "react-i18next";
import i18next from 'i18next';
import i18n from 'i18next';
import {LoadLocalStorage} from "../Helpers/LoadLocalStorage";
import { CheckUserPermission } from '../../AppSystem/Helpers/CheckUserPermission';
import useApiCallService from '../Helpers/ApiCall';
import DashboardResponse from '../Models/Response/DashboardResponse';
import { API_URL } from '../../config';
import ReactQuill from 'react-quill';
import { CustomButton } from '../Components/Button/CustomButton';
import { FlashMessage } from '../Helpers/FlashMessage';
import DashboardRequest from '../Models/Request/DashboardRequest';
import { CheckUserRole } from '../../AppSystem/Helpers/CheckUserRole';

export function Dashboard() {
    const { ApiCall } = useApiCallService();
    const { t } = useTranslation();
    const [executeEffect, setExecuteEffect] = useState(false);
    const [apiResponse, setApiResponse] = useState(new DashboardResponse());
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [fields, setFields] = useState(new DashboardRequest());
    const [value, setValue] = useState('');

    let permissionUpdate = false;
    if (CheckUserPermission("edit-dashboard")) {
        permissionUpdate = true;
    }

    useEffect(() => {
        if (i18next.language !== LoadLocalStorage('selectedLanguage')){
            i18n.changeLanguage(LoadLocalStorage('selectedLanguage'));
        }
        if (executeEffect === false) {
            setExecuteEffect(true);
        }
    }, [executeEffect]);

    const extractBase64Images = (html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const images = Array.from(doc.querySelectorAll("img"));
        const base64Images = [];

        images.forEach((img, index) => {
            const src = img.getAttribute("src");
            if (src && src.startsWith("data:image")) {
                base64Images.push({ base64: src, node: img, index });
            }
        });

        return { doc, base64Images };
    };

    const base64ToFile = (base64, filename = 'image.jpg') => {
        const arr = base64.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) u8arr[n] = bstr.charCodeAt(n);

        return new File([u8arr], filename, { type: mime });
    };

    useEffect(() => {
        let isMounted = true;
        const handleApiResponse  = (response) => {
            if (!isMounted) return;
            if(response){
                setApiResponse(response);
                setValue(response.body);
            }             
        };

        const GetDashboardSettings = async () => {
            try {
                const apiCallOptions = {
                    method: "get",
                    url: "/dashboard",
                };
                await ApiCall(apiCallOptions, handleApiResponse);
            } catch (error) {
                console.log('error', error);
            }
        };
        GetDashboardSettings();

        return () => {
            isMounted = false;
        };
    }, []);
    

    const uploadImagesAndReplace = async (html) => {
        const { doc, base64Images } = extractBase64Images(html);
        let uploadedImageIds;

        for (const { base64, node } of base64Images) {
            try {
                const file = base64ToFile(base64);
                const formData = new FormData();
                formData.append('file', file);

                const apiCallOptions = {
                    method: "post",
                    url: "/file",
                    data: formData,
                    dataTypes: "file",
                };

                await ApiCall(apiCallOptions, (response) => {
                    if (response && response.id) {
                        const imageUrl = `${API_URL}/file?id=${response.id}`;
                        node.setAttribute("src", imageUrl);
                        uploadedImageIds = response.id;
                    }
                });
            } catch (uploadError) {
                FlashMessage("validationMessage.sendError", "flash-messageError");
            }
        }

        return {
            html: doc.body.innerHTML,
            imageIds: uploadedImageIds,
        };
    };


    const handleSave = async (value) => {
            setLoading(true);
            setIsEditing(false);

            const { html, imageId } = await uploadImagesAndReplace(value);

            try {
                const apiCallOptions = {
                    method: "put",
                    url: "/dashboard",
                    data: {
                        ...fields,
                        body: html,
                        fileId: imageId,
                        
                    }
                };
                await ApiCall(apiCallOptions, setApiResponse);
                
            } 
            catch (err) {
                FlashMessage(t('validationMessage.sendError'), 'flash-messageError');
            } 
            finally {
                setLoading(false);
            }
    };

    const handleChange = () => {
        setIsEditing(false)
        handleSave(value);
    };    


    const modules = {
        toolbar: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic', 'underline','strike', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
        ['link', 'image'],
        ['clean']
        ],
    }

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet', 'indent',
        'link', 'image'
    ]

    return (
        <>
         {isEditing ? (
            <Col lg={6} className=' pb-5 offset-md-3'>
            {apiResponse ? (
                <Card className='card-backend p-3 p-lg-5'>                  
                    <Row className='justify-content-center'>                        
                        <Col lg={12}>
                            <ReactQuill modules={modules} formats={formats} theme="snow" value={value} onChange={setValue} />
                            <Col xs="auto" className="text-end mt-3">
                                <CustomButton
                                    icon="bx bx-x py-1"
                                    iconColor='#EB5757'
                                    iconSize={5}
                                    buttonColor='#e9cbcd'
                                    buttonRadius={3}
                                    hoverButtonRadius={3}
                                    hoverIconColor="white"
                                    hoverButtonColor='#EB5757'
                                    customClasses="edit-button me-2"
                                    onClick={() => setIsEditing(false)}
                                    tooltipText={t("button.cancel")}
                                />
                                <CustomButton
                                    icon="bx bx-save py-1"
                                    iconColor="#157553"
                                    iconSize={5}
                                    buttonColor="#bed1cd"
                                    buttonRadius={3}
                                    hoverButtonRadius={3}
                                    hoverIconColor="white"
                                    hoverButtonColor="#157553"
                                    customClasses="edit-button"
                                    onClick={() => handleChange()}
                                    tooltipText={t("button.save")}
                                />                               
                            </Col>
                        </Col>
                        <Col className='justify-content-center col-auto'>
                            <img src={LogoLRF} />
                        </Col>
                    </Row>
                </Card>
            ) : (
                <Card className='card-backend p-3 p-lg-5 d-flex justify-content-center align-items-center' style={{ height: '200px' }}>
                    <Spinner
                        color='success'
                        style={{ width: '4rem', height: '4rem' }}
                    />
                </Card>
            )}
            </Col>
             ) : (
                <Col lg={6} className=' pb-5 offset-md-3'>
            {apiResponse?.fileId ? (
                <Card className='card-backend p-3 p-lg-4'>
                    {permissionUpdate ? (
                    <Col xs="auto" className="text-end">
                        <CustomButton
                            icon="bx bx-edit py-1"
                            iconColor="#157553"
                            iconSize={5}
                            buttonColor="#bed1cd"
                            buttonRadius={3}
                            hoverButtonRadius={3}
                            hoverIconColor="white"
                            hoverButtonColor="#157553"
                            customClasses="edit-button"
                            onClick={() => setIsEditing(true)}
                            tooltipText={t("button.edit")}
                        />            
                    </Col>  
                     ) : ("")}
                    <Col className=' p-3 p-lg-3'>                            
                        <Row className='justify-content-center'>                        
                            <Col lg={12}>
                                <div
                                    style={{
                                        textAlign: 'left',
                                        direction: 'ltr',
                                        maxWidth: '100%',
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: value.replace(
                                        /<img /g,
                                        '<img style="max-width: 100%; height: auto; display: block; margin: 0.5rem 0;" '
                                        )
                                    }}
                                />
                            </Col>
                            <Col className='justify-content-center col-auto'>
                                <img src={LogoLRF} />
                            </Col>
                        </Row>
                    </Col>
                </Card>
            ) : (
                <Card className='card-backend p-3 p-lg-5 d-flex justify-content-center align-items-center' style={{ height: '200px' }}>
                    <Spinner
                        color='success'
                        style={{ width: '4rem', height: '4rem' }}
                    />
                </Card>
            )}
            </Col>
             )}
        </>
    );
}